import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateObject } from '../../../shared/utility';

import API_BASE from '../../../api/apiBase'
import API_CONFIG from '../../../api/apiConfig'

import { Form, Input, InputNumber, Select, TreeSelect, Switch, DatePicker, Button, Space, notification, Tabs, Typography } from 'antd';
import { Upload, message } from 'antd';
import { Alert, List } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { InfoCircleOutlined, CheckOutlined, CloseOutlined, PlusSquareOutlined, LeftCircleOutlined } from '@ant-design/icons';

import languageManager from '../../../services/languageManager';
import * as storeActions from './store/actions/suppliers';

import Loader from '../../common/PageElements/Loader';
import PageHeader from '../../common/PageElements/PageHeader'

class SuppliersImport extends Component {

   state = {
      action: undefined,
      saveAndClose: false,
      loader: true,
      importLoader: false,
      formValues: {},
      componentLanguage: this.props.authState.defaultLanguage,
      tax_rates: [],
      marketplaces: [],
      draggerDisable: false,
      import_type: [
         {
            id: 1,
            name: 'Importazione completa'
         },
         {
            id: 2,
            name: 'Importazione incrementale'
         },
      ],
      file_map_products: [
         {
            id: 1,
            name: 'File NZT'
         },
         // {
         //    id: 2,
         //    name: 'File Privalia'
         // },
         // {
         //    id: 3,
         //    name: 'File prezzi'
         // },
      ]
   };

   componentDidMount() {
      const formValues = {
         language: this.state.componentLanguage
      }
      this.setState({ formValues: formValues, loader: false });
   }

   onFinish = values => {
      console.log(values);
      this.setState({ importLoader: true });
      const data = {};
      data.language = values.language;
      data.file_path = values.fileImport[0].response.data.file_path;
      data.file_name = values.fileImport[0].response.data.file_name;
      data.import_type = values.import_type;
      data.overwrite_empty = values.overwrite_empty;
      data.map = values.map;
      if (!data.file_path || !data.file_name) {
         this.setState({ loader: false, draggerDisable: false });
         notification.open({
            message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
            description: languageManager.getMessage(this.props.commonState, 'notification.error.dataNotValid'),
            icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
         })
      }
      else {
         storeActions.importFromCSV(data)
            .then(response => {
               console.log(response);
               try {
                  // this.props.history.goBack();
                  this.setState({ response: response.data, importLoader: false, draggerDisable: false });

                  notification.open({
                     message: languageManager.getMessage(this.props.commonState, 'notification.confirm.title'),
                     description: languageManager.getMessage(this.props.commonState, 'notification.confirm.importOk'),
                     icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                  })
               } catch (e) {
                  this.setState({ importLoader: false, draggerDisable: false });
                  notification.open({
                     message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                     description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                     icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                  })
               }

            }).catch((e) => {
               this.setState({ importLoader: false, draggerDisable: false });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            });
      }
   };

   onFinishFailed = errorInfo => {
      notification.open({
         message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
         description: languageManager.getMessage(this.props.commonState, 'notification.error.formInvalid'),
         icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
      })
   };

   setDefaultLanguageHandler = (value) => {
      console.log(value);
      const updatedValues = this.setForm(this.state.response, value);
      this.setState({ formValues: updatedValues, componentLanguage: value })
   }


   render() {
      if (this.state.loader) return <Loader />;
      const layout = {
         // layout: 'inline',
         labelCol: { span: 8 },
         wrapperCol: { span: 16 },
      };
      const { Option } = Select;
      const scope = this;

      const normFile = e => {
         console.log('Upload event:', e);
         if (Array.isArray(e)) {
            return e;
         }
         return e && e.fileList;
      };

      const draggerProps = {
         name: 'file',
         multiple: false,
         disabled: this.state.draggerDisable,
         action: API_BASE.url + API_CONFIG.appUrls.files.fileImport,
         onChange(info) {
            scope.setState({ draggerDisable: info.fileList.length });
            console.log("CHANGE: ", info);
            const { status } = info.file;
            if (status !== 'uploading') {
               console.log(info.file, info.fileList);
            }
            if (status === 'done') {
               message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
               message.error(`${info.file.name} file upload failed.`);
            }
         },
      };

      let form = (
         <Form
            {...layout}
            id="importFile"
            name="basic"
            initialValues={this.state.formValues}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
         >
            <Form.Item
               name="fileImport"
               rules={[{ required: true, message: 'Scegli un file' }]}
               valuePropName="fileList"
               getValueFromEvent={normFile}
               colon={false}
               wrapperCol={24}
            >
               <Upload.Dragger {...draggerProps}>
                  <p className="ant-upload-drag-icon">
                     <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">
                     Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                     band files
                  </p>
               </Upload.Dragger>
            </Form.Item>
            {/* <Form.Item
               label="Tipo di importazione"
               name="import_type"
               rules={[{ required: true, message: 'Scegli il tipo di importazione' }]}
            >

               <Select
                  showSearch
                  size="large"
                  // className="width-70px-I"
                  placeholder="Seleziona il tipo di importazione"
                  optionFilterProp="children"
               >
                  {
                     this.state.import_type.map((map) => {
                        return <Option key={map.id} value={map.id}>{map.name}</Option>
                     })
                  }
               </Select>

            </Form.Item> */}
            <Form.Item
               label="Sovrascrivi i campi vuoti"
               name="overwrite_empty"
            >
               <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
               />
            </Form.Item>
            <Form.Item
               label="Tipo di file"
               name="map"
               rules={[{ required: true, message: 'Scegli il tipo di file' }]}
            >

               <Select
                  showSearch
                  size="large"
                  // className="width-70px-I"
                  placeholder="Seleziona il tipo di file"
                  optionFilterProp="children"
               >
                  {
                     this.state.file_map_products.map((map) => {
                        return <Option key={map.id} value={map.id}>{map.name}</Option>
                     })
                  }
               </Select>

            </Form.Item>
            <Form.Item label="language" name="language" noStyle><Input type="hidden" /></Form.Item>
         </Form>
      );


      // const specific_prices_columns = [
      //    {
      //    title: 'Nazione',
      //    dataIndex: 'country',
      //    key: 'country'
      //    },
      //    {
      //       title: 'Ecommerce',
      //       dataIndex: 
      //    }
      // ]


      const pageContent = (
         <div className="card">
            <div className="card-header">
               <div className="align-items-center row">
                  <div className="col-sm-12">
                     <div className="float-right d-none d-md-block">
                        <Space>
                           {
                              this.props.authState.userData.languages ? (
                                 <Select
                                    showSearch
                                    size="large"
                                    className="width-70px-I"
                                    placeholder="Seleziona la lingua"
                                    defaultValue={this.state.componentLanguage.toUpperCase()}
                                    optionFilterProp="children"
                                    onChange={this.setDefaultLanguageHandler}
                                 //  onFocus={onFocus}
                                 //  onBlur={onBlur}
                                 //  onSearch={onSearch}
                                 //  filterOption={(input, option) =>
                                 //    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                 //  }
                                 >
                                    {
                                       this.props.authState.userData.languages.map((lang) => {
                                          return <Option key={lang.value} value={lang.value}>{lang.label}</Option>
                                       })
                                    }
                                 </Select>
                              ) : null
                           }
                        </Space>
                     </div>
                  </div>
               </div>
            </div>
            <div className="card-body">
               {
                  this.state.response && this.state.response.successes && this.state.response.successes.length ?
                     <Alert
                        closable
                        message="Importazione completata"
                        description={<List
                           size="small"
                           dataSource={this.state.response.successes}
                           renderItem={item => <List.Item className='padding-0-I'>{item}</List.Item>}
                        />}
                        type="success"
                        showIcon
                     />
                     : ''
               }
               {
                  this.state.response && this.state.response.warnings && this.state.response.warnings.length ?
                     <Alert
                        closable
                        message="Attenzione"
                        description={<List
                           size="small"
                           dataSource={this.state.response.warnings}
                           renderItem={item => <List.Item className='padding-0-I'>{item}</List.Item>}
                        />}
                        type="warning"
                        showIcon
                     />
                     : ''
               }
               {
                  this.state.response && this.state.response.logs && this.state.response.logs.length ?
                     <Alert
                        closable
                        message="Dettagli importazione"
                        type="info"
                        description={<List
                           size="small"
                           dataSource={this.state.response.logs}
                           renderItem={item => <List.Item className='padding-0-I'>{item}</List.Item>}
                        />}
                        showIcon
                     />
                     : ''
               }
               {form}
            </div>
            <div className="card-footer">
               <div className="align-items-center row">
                  <div className="col-sm-6">

                     <Space>
                        <Button
                           size='large'
                           onClick={() => { this.props.history.goBack() }}
                        >
                           <i className="mdi mdi-arrow-left-drop-circle-outline mr-1"></i>
                           {languageManager.getMessage(this.props.commonState, 'common.back')}
                        </Button>
                     </Space>
                  </div>

                  <div className="col-sm-6">
                     <div className="float-right d-none d-md-block">

                        <Space>
                           <Button form="importFile" onClick={() => window.location.reload()} loading={this.state.importLoader}>Annulla</Button>
                           <Button form="importFile" type="primary" htmlType="submit" loading={this.state.importLoader}>Importa</Button>
                        </Space>

                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
      const helpButton = {
         title: "Aiuto"
      }

      const buttons = [];
      buttons.push(helpButton);




      console.log(this.state);
      // this.props.action === 'edit' ? (
      //    initial_values = {
      //       name: this.props.itemData.t_name,
      //       percentage: this.props.itemData.percentage
      //    }) : null;

      return (
         <div className="container-fluid">
            <PageHeader
               title={languageManager.getMessage(this.props.commonState, 'component.products.title')}
               buttons={buttons}
            />
            <div className="row">
               <div className="col">
                  {pageContent}
               </div>
            </div>
         </div>

      );
   }
}

const mapStateToProps = state => {
   return {
      authState: state.authenticationState,
      commonState: state.commonState
   };
};

// const mapDispatchToProps = dispatch => {
//     return {
//         onFetchTaxRates: () => dispatch( actions.getTaxRatesList() )

//     };
// };

export default connect(mapStateToProps)(SuppliersImport);